import './ContactInfo.css';
import location from '../../../src/assets/img/location.svg';
import phoneInfo from '../../../src/assets/img/phoneInfo.svg';
import mail from '../../../src/assets/img/mail.svg';

function ContactInfo({image, alt, title, content}) {
    const images = {
        location,
        phoneInfo,
        mail
    };

    return (
      <div className="d-flex align-items-center mt-4 gap-3">
        <div className="info-images">
          <img src={images[image]} alt={alt} />
        </div>
        <div className="d-flex flex-column">
          <span className="title-info mb-2">{title}</span>
          {content.map((item, index) => (
            <span key={index} className="content-info">{item}</span>
          ))}
        </div>
      </div>
    );
};

export default ContactInfo;